// The session a proof page can see, read straight from the sign-in client.
//
// Lives in its own module, loaded lazily, for the same reason tickerAuth.ts
// does: rbIndexes.ts is imported by prerendered entries that must never pull
// the Supabase client into their bundle, and a test guards that file's text.

/** The session this page can see, read straight from the sign-in client —
 *  the same storage the admin desk uses. Null when nobody is signed in here.
 *  Exported so a refusal can say which of the two it was. */
export async function proofSession(): Promise<{ token: string; email: string | null } | null> {
  try {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const t = data.session?.access_token;
    return t ? { token: t, email: data.session?.user?.email ?? null } : null;
  } catch {
    return null;
  }
}


/** What the server resolves for a request sent exactly the way the keyed
 *  calls send it. For the refusal message, so the cause is named. */
export async function proofWhoami(bearer: string | null): Promise<string> {
  const url = import.meta.env?.VITE_SUPABASE_URL;
  const key = import.meta.env?.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!url || !key) return "no project configured";
  try {
    const res = await fetch(`${url}/rest/v1/rpc/rb_index_whoami`, {
      method: "POST",
      headers: { apikey: key, authorization: `Bearer ${bearer ?? key}`, "content-type": "application/json", accept: "application/json" },
      body: "{}",
    });
    if (!res.ok) return `whoami HTTP ${res.status}`;
    const w = (await res.json()) as Record<string, unknown>;
    return `server saw uid ${w.uid ?? "none"}, role ${w.role ?? "none"}, email ${w.email ?? "none"}, admin ${String(w.is_admin)}, claims ${String(w.claims_present)}`;
  } catch (e) {
    return `whoami failed: ${(e as Error).message}`;
  }
}
